(function detailsDataProviderInitLambda(global) {


  /** 
  * Источник данных для грида.
  * @since 5.2.0.1300
  */
  var DetailsDataProvider = WA.CMP.dataViews.BaseDataProvider.extend({
    _DetailSectionNumber: null,
    _DFMName: null,

    init: function (initialState) {
      var me = this;

      me._super(initialState);
      me._cacheID = generateUniqueID();
      me._DetailSectionNumber = initialState.DetailSectionNumber;
      me._DFMName = initialState.DFMName;
      
      me.defaults = {
        ObjectLink: new WA.Link().toLinkModel()        
      }
      
      $.extend(me.defaults, initialState);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _makeKey: function () {
      var me = this;
      var code;
      if (WA.CR.Type === OBJECT_TYPE.EDOCUMENT) {
        code = "" + WA.CR.CardTypeCode;
      }

      if (WA.CR.Type === OBJECT_TYPE.REFERENCE_RECORD) {
        code = "" + WA.CR.getReferenceCode();
      }
      return $.toJSON([code, ""+WA.CR.getReferenceView(), ""+me._DetailSectionNumber]).replaceAll(' ','');
    },

    /**
    * @since 5.2.0.1300
    */
    makeParams: function (loadOptions) {
      var me = this;
      loadOptions.CacheID = me._cacheID;
      return me.extendDefaults(loadOptions);
    },

    /**
     * Загрузить список записей.
     *
     * @method load
     * @param {Object} loadOptions Опции загрузки.
     * @return {Deferred<Object>} Загруженные записи.
     * @since 5.2.0.1300
     * @see https://api.jquery.com/category/deferred-object/
     */
    load: function (loadOptions) {
      var me = this;
      var result = new $.Deferred();
      WA.SRV.call('/CardForm.asmx/GetDetailsData', me.makeParams(loadOptions)).always((data) => {
        let rowsList = data.Error ? [] : $.parseJSON(data);
        result.resolve({ Rows: rowsList });
      });
      return result.promise();
    },

    /**
     * Загрузить состояние.
     *
     * @method loadState
     * @return {Deferred<Object>} Состояние.
     * @see https://api.jquery.com/category/deferred-object/
     */
    loadState: function () {
      var me = this;
      var result = $.Deferred();
      var jTable = $('#'+me._DFMName);

      var data = jTable.data('state');
      if (data && data["ObjectLink"]) delete data["ObjectLink"]; //В профиле может быть неактуальная ссылка
      result.resolve(data);

      return result;
    },

    /**
     * Сохранить состояние.
     *
     * @param {Object} loadOptions Опции загрузки.
     * @param {boolean} forceSaveToServer Признак принудительной загрузки на сервер.
     * @return {Deferred<void>}
     * @see https://api.jquery.com/category/deferred-object/
     */
    saveState: function (loadOptions, forceSaveToServer) {
      var me = this;
      var result = $.Deferred();      
      clearTimeout(me._saveSateTimeout);
      WA.cache.serverCache.setItem(me._makeKey(), me.makeParams(loadOptions)).done(function () {
        result.resolve();
      }).fail(function () {
        result.reject();
      });
      return result.promise();
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });


  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  // Публичные объекты.
  global.DetailsDataProvider = DetailsDataProvider;
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core.grid);